<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" v-if="mode === 'view'">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <button
                    v-show="isShowEditBtn"
                    @click="changeMode('edit')"
                    type="button"
                    class="btn btn-warning waves-effect waves-light"
                  >
                    <i class="mdi mdi-pencil label-icon"></i>
                    Edit Tech Products
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Id</label>
              <label class="col-form-label col-lg-8">{{ model.id }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Product Name</label>
              <label class="col-form-label col-lg-8">
                {{ model.display_name }}
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Product Code</label>
              <label class="col-form-label col-lg-8">
                {{ model.product_code }}
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Application</label>
              <label class="col-form-label col-lg-8">
                {{ model.application_info.display_name }}
                <label class="label label-complete ml-2">
                  {{ model.application_info.code }}
                </label>
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Service</label>
              <label class="col-form-label col-lg-8">
                {{ model.service_info.service_name }}
                <label class="label label-complete ml-2">
                  {{ model.service_info.service_domain }}
                </label>
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Product Type</label>
              <label class="col-form-label col-lg-8">
                {{ model.tech_product_type }}
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">URL Webhook</label>
              <label class="col-form-label col-lg-8">
                {{ model.tech_product_url_webhook }}
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">สถานะ</label>
              <label class="col-form-label col-lg-8">
                <label :class="`label label-${statusLabel}`">
                  {{ model.status }}
                </label>
              </label>
            </div>

            <div class="form-group mb-4 text-left">
              <div class="button-items">
                <button type="button" class="btn btn-light" @click="onBack()">
                  <i class="bx bx-arrow-back" />
                  Back
                </button>
              </div>
            </div>
          </div>
          <div class="card-body" v-else-if="mode === 'new' || mode === 'edit'">
            <validationObserver ref="addDataForm">
              <!-- <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset"> -->
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">
                  ชื่อ Product (อังกฤษ)
                </label>
                <div class="col-lg-6">
                  <validationProvider
                    v-slot="{ errors }"
                    name="Product English Name"
                    :rules="{
                      dynamicRequired: ['กรุณาระบุชื่อ Product เป็นภาษาอังกฤษ'],
                      duplicateName: [
                        isValidate.display_name,
                        'ชื่อภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
                      ],
                      validateEnglishSpace: true,
                    }"
                  >
                    <div class="input-group check-length">
                      <div class="input-group-prepend">
                        <div class="input-group-text">EN</div>
                      </div>
                      <input
                        id="input_displayname"
                        name="input_displayname"
                        type="text"
                        class="form-control"
                        placeholder="ระบุชื่อภาษาอังกฤษ"
                        v-model="model.display_name"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) && model.display_name,
                        }"
                      />
                      <!-- <span class="input-validate-length"> {{ model.display_name.length }}/30 </span> -->
                    </div>
                    <div
                      v-if="errors && errors.length"
                      class="validate-invalid"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2"> Product Code </label>
                <div class="col-lg-6">
                  <validationProvider
                    v-slot="{ errors }"
                    name="Product Code English Name"
                    :rules="{
                      dynamicRequired: [
                        'กรุณาระบุชื่อ Product Code เป็นภาษาอังกฤษ',
                      ],
                      duplicateName: [
                        isValidate.product_code,
                        'ชื่อภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
                      ],
                      validateEnglish: true,
                    }"
                  >
                    <div class="input-group check-length">
                      <div class="input-group-prepend">
                        <div class="input-group-text">EN</div>
                      </div>
                      <input
                        id="input_product_code"
                        name="input_product_code"
                        type="text"
                        class="form-control"
                        placeholder="ระบุชื่อภาษาอังกฤษ"
                        v-model="model.product_code"
                        :class="{
                          'is-invalid': errors && errors.length,
                          'is-valid':
                            !(errors && errors.length) && model.product_code,
                        }"
                      />
                    </div>
                    <div
                      v-if="errors && errors.length"
                      class="validate-invalid"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2"> Service </label>
                <div class="col-lg-6">
                  <validationProvider
                    v-slot="{ errors }"
                    name="View Service"
                    :rules="{ required: true }"
                  >
                    <div class="input-group check-length">
                      <multiselect
                        v-model="model.service_id"
                        :options="optionsService.map((it) => it.service_id)"
                        :custom-label="(val) => findOptionsService(val)"
                        @select="
                          (val) => {
                            model.service_info.service_domain =
                              optionsService.find(
                                (it) => it.service_id === val
                              ).service_domain;
                            model.service_info.service_name =
                              optionsService.find(
                                (it) => it.service_id === val
                              ).service_name;
                          }
                        "
                        :show-labels="false"
                        placeholder="Select an Service"
                        label="service"
                        required
                      ></multiselect>
                    </div>
                    <div
                      v-if="errors && errors.length"
                      class="validate-invalid"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
              </div>
              <div class="form-group row mb-4" v-if="mode !== 'new'">
                <label class="col-form-label col-lg-2"> Application </label>
                <div class="col-lg-4">
                  <div class="input-group check-length">
                    <input
                      id="input_app_namespace"
                      name="input_app_namespace"
                      type="text"
                      class="form-control"
                      placeholder="Service"
                      disabled
                      :value="`${model.application_info.display_name} (${model.application_info.code})`"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">
                  Tech Product Type
                </label>
                <div class="col-lg-4">
                  <div class="input-group check-length">
                    <multiselect
                      v-model="model.tech_product_type"
                      :options="['API']"
                      placeholder="Select an Product Type"
                      disabled
                    ></multiselect>
                  </div>
                </div>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2"> URL Webhook </label>
                <div class="col-lg-6">
                  <div class="input-group check-length">
                    <div class="input-group-prepend">
                      <div class="input-group-text">EN</div>
                    </div>
                    <input
                      id="input_tech_product_url_webhook"
                      name="input_tech_product_url_webhook"
                      type="text"
                      class="form-control"
                      placeholder="ระบุ URL Webhook"
                      v-model="model.tech_product_url_webhook"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">สถานะ</label>
                <div class="col-lg-2">
                  <basic-select
                    :options="optionsStatus"
                    :reload="reloadStatusSelector"
                    :selected-option="{
                      text: model.status,
                      value: model.status,
                    }"
                    @select="onStatusSelector($event)"
                    placeholder="ระบุสถานะ"
                    v-bind:isError="isValidate.status"
                  >
                  </basic-select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="text-left">
                    <div class="button-items">
                      <button
                        type="button"
                        class="btn btn-light"
                        @click="onBack()"
                      >
                        <i class="bx bx-arrow-back" />
                        Back
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="text-right">
                    <div class="button-items">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="onSubmit"
                      >
                        <i class="bx bx-save" />Save
                      </button>
                      <button
                        type="button"
                        class="btn btn-light"
                        @click="onConfirmReset"
                      >
                        <i class="bx bx-reset" />Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </form> -->
            </validationObserver>
          </div>
        </div>
        <b-row>
          <b-col cols="12">
            <b-card title="Apply Client Apps">
              <b-row>
                <b-col cols="12">
                  <div class="text-right">
                    <b-button
                      variant="success"
                      :to="{
                        name: 'tech_products_apply_client_apps',
                        params: { id, client_apps_id: 'new' },
                      }"
                    >
                      <i class="bx bx-plus font-size-16 align-middle mr-2"></i>
                      Apply Client Apps
                    </b-button>
                  </div>
                </b-col>
                <b-col cols="12">
                  <TableView
                    :isShowChangePerPage="false"
                    :isShowPagination="false"
                    :items="itemsClientApps"
                    :fields="fieldsClientApps"
                  >
                    <template v-slot:cell(action)="data">
                      <div class="text-center">
                        <a
                          @click="redirectClientAppsDetail(data)"
                          class="btn btn-ico text-info"
                          title="View"
                          ><i class="bx bx-show"></i
                        ></a>
                      </div>
                    </template>
                  </TableView>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";

import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import techProductsService from "@/helpers/service/tech-products-service";
import { eventBus } from "@/main.js";
import { StatusEnum } from "@/enum/status.enum.js";
import { BasicSelect } from "vue-search-select";
import { OptionDropdownStatus } from "@/helpers/utils/status.js";
import serviceClientAppsService from "@/helpers/service/service-client-apps-service.js";
import Multiselect from "vue-multiselect";
import TableView from "@/components/share/table-view.vue";

export default {
  page: {
    title: "Tech Products Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    "basic-select": BasicSelect,
    Multiselect,
    TableView,
  },
  data() {
    return {
      id: "",
      title: "View",
      mode: "view",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Tech Products",
          href: "/tech-products",
        },
        {
          text: "View",
          active: true,
        },
      ],
      reloadTypeSelector: false,
      modelOriginal: {},
      model: {
        id: null,
        application_id: null,
        application_info: {
          code: null,
          display_name: null,
        },
        service_id: null,
        service_info: {
          service_name: null,
          service_domain: null,
        },
        display_name: null,
        product_code: null,
        tech_product_type: "API",
        status: StatusEnum.ACTIVE,
        tech_product_url_webhook: "",
      },
      fields: [{ id: 1, isValidate: { value_en: false, value_th: false } }],
      isValidate: {
        display_name_th: false,
        display_name: false,
        contact_email: false,
      },
      reloadStatusSelector: false,
      optionsStatus: [],
      messageAlertConfirm: "",
      canUpdateDeleteStatus: {
        isDelete: true,
        isConfirm: "",
      },
      optionsService: [],
      originalModel: {},
      itemsClientApps: [],
      fieldsClientApps: [
        {
          key: "index",
          label: "Index",
          sortable: true,
        },
        {
          key: "client_apps_id",
          label: "Client Apps Id",
          sortable: false,
        },
        {
          key: "client_apps_information.display_name",
          label: "Name",
          sortable: false,
        },
        {
          key: "client_apps_information.contact_email",
          label: "Contact Email",
          sortable: false,
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    isShowEditBtn() {
      return !(
        this.model.status === "Delete" || this.model.status === "Pending"
      );
    },
    statusLabel() {
      return this.model !== null &&
        this.model.status !== "" &&
        this.model.status
        ? this.model.status.toLowerCase()
        : "";
    },
  },
  watch: {
    "model.display_name": {
      async handler(val) {
      //  console.log("val", val);
        await this.onValidateDisplaynameEN(val);
      },
      deep: true,
    },
  },
  created: function () {
    if (this.$route.params.id == "new") {
      this.mode = "new";
      this.title = "New Tech Products";
      this.items[2].text = "New";

      setTimeout(() => {
        document.title = `New Tech Products | ${appConfig.description}`;
      }, 100);
    } else {
      this.title = "Detail";
      this.items[2].text = "Detail";
      this.id = this.$route.params.id;

      setTimeout(() => {
        document.title = `Edit Detail | ${appConfig.description}`;
      }, 100);
    }
    if (this.$route.query.mode) {
      this.title = "Edit TechProducts";
      this.items[2].text = "Edit";
      this.mode = this.$route.query.mode;
    }
  },
  mounted: function () {
    this.getServiceClientAppsAsync();
    if (this.mode !== "new") {
      this.optionsStatus = OptionDropdownStatus;
      this.getDetail();
      this.getTechProductClientAppsAsync();
    } else {
      this.optionsStatus = OptionDropdownStatus.filter(
        (s) => s.text !== StatusEnum.DELETE
      );
    }
  },
  methods: {
    findOptionsService(val) {
      return this.optionsService.some((it) => it.service_id === val)
        ? this.optionsService.find((it) => it.service_id === val).text
        : "";
    },
    redirectClientAppsDetail(data) {
    //  console.log("this", this.id);
      var _this = this;
      this.$router.push({
        name: "tech_products_apply_client_apps",
        params: {
          id: _this.id,
          client_apps_id: data.item.client_apps_id,
        },
      });
    },
    async getDetail() {
      const vm = this;
      let result = await techProductsService.getTechProductAsync(this.id);
      if (result.status === 200) {
        this.model = result.data;
      //  console.log("test", result.data);
        this.model = {
          id: result.data.id,
          application_id: result.data.application_id,
          application_info: {
            code: result.data.application_info.code,
            display_name: result.data.application_info.display_name,
          },
          service_id: result.data.service_id,
          service_info: {
            service_name: result.data.service_info.service_name,
            service_domain: result.data.service_info.service_domain,
          },
          display_name: result.data.display_name,
          product_code: result.data.product_code,
          tech_product_type: result.data.tech_product_type,
          status: result.data.status,
          tech_product_url_webhook: result.data.tech_product_url_webhook
        };
        this.modelOriginal = JSON.parse(JSON.stringify(this.model));

        // this.app_domains = [];
        // result.data.app_domains.forEach((element, index) => {
        //   vm.app_domains.push({ element });
        // });
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
    onBack() {
      if (this.mode === "edit") {
        this.mode = "view";
        this.title = "Detail";
        this.items[2].text = "Detail";
        this.getDetail();
      } else {
        this.$router.push({
          path: "/tech-products",
        });
      }
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ""
        )
        .then((result) => {
          if (result) {
           // console.log("mode", this.mode);
            if (this.mode === "new") {
              this.model.service_id = "";
              (this.model.service_info = {
                service_name: "",
                service_domain: "",
              }),
                (this.model.display_name = "");
              this.model.product_code = "";
              this.model.tech_product_type = "API";
              this.model.status = StatusEnum.ACTIVE;
              this.$nextTick(
                () => this.$refs.addDataForm.reset(),
                this.$refs.addDataForm.$children[0].reset()
              );
            } else {
              this.getDetail();
            }
          }
        });
    },
    changeMode(_mode) {
      if (_mode == "edit") {
        this.mode = "edit";
        this.title = "Edit";
        this.items[2].text = "Edit";
        // console.log(this.optionsService);
        this.getDetail();
        // this.$nextTick(
        //   () => this.$refs.addDataForm.reset()
        //   // this.$refs.addDataForm.$children[0].reset()
        // );
      }
    },
    async onSubmit() {
      this.isValidate.status = false;
      this.isValidate.type = false;

      if (!this.$validate.isValid(this.model.status)) {
        this.isValidate.status = true;
        return;
      }

      if (this.mode === "new") {
        await this.onSaveCreate();
      } else {
        await this.onSave();
        // await this.$utils
        //   .confirmAlertDisplay(`ต้องการเปลี่ยนแปลงข้อมูลนี้ใช่หรือไม่`)
        //   .then(async (result) => {
        //     if (result) await this.onSave();
        //   });
      }
    },
    async onSave() {
      await this.$refs.addDataForm.validate().then(async (response) => {
        if (response) {
          await this.$utils
            .confirmAlertDisplay(`ต้องการเปลี่ยนแปลงข้อมูลนี้ใช่หรือไม่`)
            .then(async (confirm) => {
              if (confirm) {
                this.removeLastAndFirstSpacesFromString();
                let result = await techProductsService.updateTechProductsAsync(
                  this.id,
                  this.model
                );
                if (result.status && result.status === 204) {
                  this.$utils.notification(
                    "success",
                    "แก้ไขข้อมูลสำเร็จ",
                    1500
                  );
                  this.mode = "view";
                  this.title = "Detail";
                  this.items[2].text = "Detail";
                  this.getDetail();
                } else if (
                  (result.status && result.status !== 500) ||
                  (result.response && result.response.status !== 500)
                ) {
                  this.$utils.notification(
                    "error",
                    result.response.data.message,
                    2000
                  );
                }
              }
            });
        }
      });
    },
    async onSaveCreate() {
      this.$refs.addDataForm.validate().then(async (response) => {
        if (response) {
          await this.removeLastAndFirstSpacesFromString();
          let result = await techProductsService.createTechProductsAsync(
            this.model
          );
          if (result.status === 201) {
            this.$utils.notification("success", "เพิ่มข้อมูลสำเร็จ", 1500);
            this.$router.push({
              path: "/tech-products",
            });
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notificationAck("error", result.response.data.message);
          }
        }
      });
    },
    async onValidateDisplaynameEN(display_name) {
      if (this.$validate.isTrimValid(display_name)) {
        // console.log(
        //   this.mode,
        //   this.modelOriginal.display_name.trim(),
        //   display_name.trim()
        // );
        if (
          this.mode === "edit" &&
          this.modelOriginal.display_name.trim() === display_name.trim()
        ) {
          this.isValidate.display_name = false;
          return;
        }

        let params = new URLSearchParams();
        params.append("display_name_en", display_name);
        let result = await techProductsService.headTechProductsAsync(params);
       // console.log("result", result);
        this.isValidate.display_name = result.status === 200;

        // let params = new URLSearchParams();
        // params.append("nameEn", this.model.display_name.trim());
        // if (this.mode === "edit") {
        //   params.append("id", this.id);
        // }
        // let result = await clientAppsService.headClientAppsMasterAsync(params);
        // if (result.status === 200) {
        //   this.isValidate.display_name = true;
        // } else if (
        //   (result.status && result.status === 404) ||
        //   (result.response.status && result.response.status === 404)
        // ) {
        //   this.isValidate.display_name = false;
        // } else if (
        //   (result.status && result.status !== 500) ||
        //   (result.response && result.response.status !== 500)
        // ) {
        //   if (result.response.data.message) {
        //     this.$utils.notification(
        //       "error",
        //       result.response.data.message,
        //       2000
        //     );
        //   } else {
        //     this.$utils.notification(
        //       "error",
        //       "Bad request: Unkonw error",
        //       2000
        //     );
        //   }
        // }
      }
    },
    isNotNullOrEmpty(obj) {
      return obj !== undefined && obj !== null && obj !== "";
    },
    isNotNull(obj) {
      return obj !== undefined && obj !== null;
    },
    async onValidateExists(field, index, lang) {
      let value = "";
      if (this.isNotNullOrEmpty(field.value_th) && lang === "th") {
        value = field.value_th;
        field.isValidate.value_th = false;
      }
      if (this.isNotNullOrEmpty(field.value_en) && lang === "en") {
        value = field.value_en;
        field.isValidate.value_en = false;
      }

      if (value !== "") {
        let arrayName = [];

        for (let i = 0; i < this.fields.length; i++) {
          if (index === i) {
            continue;
          }
          if (this.isNotNullOrEmpty(this.fields[i].value_en) && lang === "en")
            arrayName.push(this.fields[i].value_en);
          if (this.isNotNullOrEmpty(this.fields[i].value_th) && lang === "th")
            arrayName.push(this.fields[i].value_th);
        }

        if (arrayName.some((q) => q === value)) {
          if (lang === "th") field.isValidate.value_th = true;
          if (lang === "en") field.isValidate.value_en = true;
        }
      }
    },
    async deleteRow(index) {
      await this.$utils
        .confirmAlertDisplay(`คุณแน่ใจที่จะลบรายการใช่หรือไม่?`, "")
        .then(async (result) => {
          if (result) {
            this.fields.splice(index, 1);
            for (let i = 0; i < this.fields.length; i++) {
              await this.onValidateExists(this.fields[i], i, "th");
              await this.onValidateExists(this.fields[i], i, "en");
            }
          }
        });
    },
    AddformData() {
      this.fields.push({
        value_th: "",
        value_en: "",
        default_value: false,
        isValidate: { value_en: false, value_th: false },
      });
      de;
    },
    toggleCheckbox(index) {
      this.fields.forEach((element, i) => {
        if (
          index != i &&
          (element.default_value == "true" || element.default_value == true)
        ) {
          this.fields[i].default_value = false;
        }
      });
    },
    removeLastAndFirstSpacesFromString() {
      if (this.$validate.isValid(this.model.display_name))
        this.model.display_name = this.model.display_name.trim();
      //this.model.contact_email = this.model.contact_email.trim();
      //this.model.app_namespace = this.model.app_namespace.trim();
    },
    async onStatusSelector(data) {
      this.isValidate.status = false;
      this.reloadStatusSelector = false;

      if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        this.canUpdateDeleteStatus.isConfirm
      ) {
        this.$utils
          .confirmAlertDisplay(
            `ข้อมูลที่ถูก Delete จะไม่สามารถนำกลับมาใช้งานใหม่ได้ ต้องการ Delete ข้อมูลนี้ใช่หรือไม่`,
            ""
          )
          .then((result) => {
            if (result) this.model.status = data.text ? data.text : "";
          });
      } else if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        !this.canUpdateDeleteStatus.isConfirm
      ) {
        this.model.status = data.text ? data.text : "";
      } else if (
        data.text === StatusEnum.DELETE &&
        !this.canUpdateDeleteStatus.isDelete
      ) {
        console.log(
          "this.canUpdateDeleteStatus.isDelete",
          this.canUpdateDeleteStatus.isDelete
        );
        this.$utils.notification(
          "warning",
          "มีสินค้าสถานะพร้อมขายอยู่ในนี้ ไม่สามารถปรับสถานะเป็น Delete ได้",
          2000
        );
      } else {
        this.model.status = data.text ? data.text : "";
      }
    },
    addURL() {
      let _id = this.app_domains.length + 1;
      this.app_domains.push({ id: _id, api_url: "" });
    },
    deleteURL(index) {
      this.app_domains.splice(index, 1);
    },
    async getServiceClientAppsAsync() {
      let params = new URLSearchParams();
      params.append("allow_channels", "ClientApps");
      params.append("pageSize", 9999);
      let result = await serviceClientAppsService.getServiceClientAppsAsync(
        params
      );
      if (result.status === 200) {
        // console.log(result.data.items);
        const items = result.data.items;
        this.optionsService = items.map((it) => ({
          service_id: it.id,
          service_name: it.service_name,
          service_domain: it.service_domain,
          text: `${it.service_name} (${it.service_domain})`,
        }));
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async getTechProductClientAppsAsync() {
      const techProductId = this.id;
      let result = await techProductsService.getTechProductClientAppsAsync(
        techProductId,
        {}
      );
      if (result.status === 200) {
        //console.log("getTechProductClientAppsAsync", result.data.items);
        const items = result.data.items;
        this.itemsClientApps = items;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
  },
};
</script>
